import { Component, OnInit, ElementRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

import { jsPDF } from 'jspdf';
import * as html2canvas from 'html2canvas';



//import constants
import { AppSettings } from '../../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../../services/servicing.service';
import { ProblemSolvingService } from '../../../../../services/problem_solving.service';


import { ConfirmationDialogService } from '../../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../../services/general.service';

//import components
// import { ServicingCreateComponent } from '../../servicing-create/servicing-create.component';

// import { ServicingMaintenance } from '../../servicing-maintenance/servicing-maintenance.component';

//import { ServicingCalendarComponent } from '../servicing-calendar/servicing-calendar.component';
// import { ServicingExtraOrdinaryComponent } from '../../servicing-list/servicing-extraordinary/servicing-extraordinary.component';
// import { ServicingOrdinaryComponent } from '../../servicing-list/servicing-ordinary/servicing-ordinary.component';
// import { ServicingViewserviceComponent } from '../../servicing-list/servicing-viewservice/servicing-viewservice.component';
// import { ServicingDocumentsComponent } from '../../servicing-list/servicing-documents/servicing-documents.component';

import { ViewProblemSolvingComponent } from '../../problem_solving_list/problem-viewsolving/problem-viewsolving.component';

import { SendStakeHoldersComponent } from '../../problem_solving_list/sendstake_action/sendstake-action.component';


//import multiselectdropdown
import { IDropdownSettings } from 'ng-multiselect-dropdown';

// import * as html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { ConsultancyService } from 'src/app/services/consultancy.service';


declare var $: any;

@Component({
  selector: 'app-problem-solving-view',
  templateUrl: './problem-solving-view.component.html',
  styleUrls: ['./problem-solving-view.component.css']
})

export class ProblemSolvingViewComponent implements OnDestroy, OnInit {
  butDisabled: boolean = true;

  getPhotoBase64;

  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;

  //common data
  data: any;
  generalLang: any;
  selectedTab:any;

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableOptions3: any;
  datatableOptions4: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableColsDefs3: any;
  datatableColsDefs4: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableCols3: any;
  datatableCols4: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  viewServicingModal: BsModalRef;
  addExtraModel: BsModalRef;
  addMaintenanceModel: BsModalRef;
  deleteOption: any;
  extraordinayModal: BsModalRef;
  ordinayModal: BsModalRef;
  ordinary_data: BsModalRef;

  viewProblemSolvingModel: BsModalRef;

  lang: any;
  odlang: any;
  exodlang: any;
  generalData: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  single_data: any;
  plans: any;
  imgQR: any;
  exordinary_data: any;
  documents_data: any;
  planvals: any;
  cnt: any;
  doclang: any;
  course: any;
  rcourse: any;
  rtreatment: any;
  rphase3: any;
  rphase4: any;
  rphase5: any;
  get_action_data: any;
  treatment: any;
  treatment_settings: any;
  cause_settings: any;
  corrective_settings: any;
  check_settings: any;
  cause_analysis: any;
  corrective_actions: any;
  check_effectiveness: any;

  emp_list: any;
  emp_list1: any;
  employee: any;
  typeConfig: any;
  appClass: any;
  emp_id: any;
  cause: any;
  corrective:any
  check:any

  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');

  id: number;


  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  generalsForm: FormGroup;
  generalsFormSubmitted: Boolean = false;
  generalsFormMsg: any;

  treatmentForm: FormGroup;
  treatmentFormSubmitted: Boolean = false;
  treatmentFormErrorMsg: any;

  causeForm: FormGroup;
  causeFormSubmitted: Boolean = false;
  causeFormErrorMsg: any;

  correctiveForm: FormGroup;
  correctiveFormSubmitted: Boolean = false;
  correctiveFormErrorMsg: any;

  checkForm: FormGroup;
  checkFormSubmitted: Boolean = false;
  checkFormErrorMsg: any;


  reportForm: FormGroup;
  reportFormSubmitted: Boolean = false;
  reportFormMsg: any;

  reportTreatmentForm: FormGroup;
  reportTreatmentSubmitted: Boolean = false;
  reportTreatmentFormMsg: any;

  reportCauseForm: FormGroup;
  reportCauseSubmitted: Boolean = false;
  reportCauseFormMsg: any;

  
  reportCorrectiveForm: FormGroup;
  reportCorrectiveSubmitted: Boolean = false;
  reportCorrectiveFormMsg: any;

  
  reportFinalForm: FormGroup;
  reportFinalSubmitted: Boolean = false;
  reportFinalFormMsg: any;

  sendStakeModal: BsModalRef;

  
  rolepermission: any;


  constructor(
    private formBuilder: FormBuilder,

    private servicingService: ServicingService,
    private problemSolvingService: ProblemSolvingService,    
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,

    ) { }


  ngOnInit() {
    //fetch data

    this.data = this.route.snapshot.data['sdata'];
    // console.log(this.data);  

    var role = this.ngxRolesService.getRole('problem_solving');
    // console.log(role);
    
    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }


    this.getData();
    this.config();

    //tab2 actions
    this.tab1Actions();
    this.tab2Actions();
    this.tab3Actions();
    this.tab4Actions();
    this.tab5Actions();
    // this.tab3Actions();
    // this.tab4Actions();

    var i = 1;
    if (this.selectedTab != '')
    {
      var chk = i + 1;

      i++;
    }

    console.log(i);
  }

  config(): void {


    this.typeConfig = [
    { value: '1', text: 'Internal non conformity' },
    { value: '2', text: 'Supplier non conformity' },
    { value: '3', text: 'Claim' },
    { value: '4', text: 'Accident' },
    { value: '5', text: 'Near miss' },
    ];


    // this.appClass = [
    //   { item_id: '1', item_name: this.generalLang.product },
    //   { item_id: '2', item_name: this.generalLang.process },
    //   { item_id: '3', item_name: this.generalLang.assistance },
    //   { item_id: '4', item_name: this.generalLang.serviceDelivery },
    //   { item_id: '5', item_name: this.generalLang.calibrationService },
    //   { item_id: '6', item_name: this.generalLang.marketing },
    //   { item_id: '7', item_name: this.generalLang.purchases },
    // ];



    // this.planConfig = [
    // { value: '7', text: '33 - e3' },
    // { value: '18', text: 'sarda - add' },
    // { value: '145', text: 'S 001 - test' }
    // ];


    // this.emp_id = [
    //   { value: '886', text: 'demotest demotest' },
    //   { value: '885', text: 'dtesttest dtesttest' },
    //   { value: '523', text: 'PAOLO ROSSI' },
    //   { value: '739', text: 'Test 01' }
    // ];


  }

  onItemSelect(item: any) {
    console.log(item.item_id);
  }
  onSelectAll(items: any) {
    console.log(items);
  }


  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  pdfDownload() {
    var node = document.getElementById('QR_div');

    htmlToImage.toJpeg(node)
    .then(function (dataUrl) {
        // console.log(dataUrl); return false;
        var img = new Image();
        img.src = dataUrl;
        // document.body.appendChild(img);
        document.getElementById("imgQRD").click();
      })
    .catch(function (error) {
      console.error('oops, something went wrong!', error);
    });

  }

  datatableConfig(): void {

    this.datatableColumns();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs1,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        table1
        .on('select deselect', function (e, dt, type, indexes) {

          var table1 = new $.fn.dataTable.Api('#table1');
          var selected = table1.rows({ selected: true }).indexes().toArray();

          if (selected.length === 0)
            self.deleteOption = false;
          else
            self.deleteOption = true;
        });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
          {
            extend: 'csv',
            text: 'Export CSV',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table1');
                var selected = dt.rows({ selected: true }).indexes().toArray();
                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'pdfHtml5',
            text: 'Export PDF',
            className: 'btn btn-info',
            orientation: 'landscape',
            pageSize: 'A3',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table1');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;


                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'excel',
            text: 'Export Excel',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table1');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'print',
            text: 'Print',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table1');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          ], select: true
        }).container().appendTo($('#datatableExportBtn1'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig1(): void {

    this.datatableColumns1();

    this.datatableOptions2 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs2,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table2 = new $.fn.dataTable.Api('#table2');

          var count = table2.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table2.rows().deselect();
            selected = false;
          }
          else
            table2.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table2 = new $.fn.dataTable.Api('#table2');

        table2
        .on('select deselect', function (e, dt, type, indexes) {

          var table2 = new $.fn.dataTable.Api('#table2');
          var selected = table2.rows({ selected: true }).indexes().toArray();

          if (selected.length === 0)
            self.deleteOption = false;
          else
            self.deleteOption = true;
        });

        var buttons2 = new $.fn.dataTable.Buttons(table2, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
          {
            extend: 'csv',
            text: this.exodlang.exportCsv,
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table2');
                var selected = dt.rows({ selected: true }).indexes().toArray();
                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'pdfHtml5',
            text: this.exodlang.exportPdf,
            className: 'btn btn-info',
            orientation: 'landscape',
            pageSize: 'A3',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table2');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;


                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'excel',
            text: this.exodlang.exportExcel,
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table2');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'print',
            text: this.exodlang.exportPrint,
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table2');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          ], select: true
        }).container().appendTo($('#datatableExportBtn2'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig2(): void {
    this.datatableColumns2();

    this.datatableOptions3 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs3,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {
        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          let vcnt = $('th:first-child input').val();
          // console.log(vcnt);

          $('.dmulval').val('');

          for (let i = 1; i <= vcnt; i++) {
            if ($('.chk' + i).is(":checked")) {
              var table3 = new $.fn.dataTable.Api('.otable' + i);

              var count = table3.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table3.rows().deselect();
                selected = false;
              }
              else
                table3.rows().select();

              $('th:first-child input', thead).prop("checked", selected);
              $('.odplus_del' + i).css('display', 'inline-block');
            }
            else {
              var table3 = new $.fn.dataTable.Api('.otable' + i);
              var count = table3.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table3.rows().deselect();
                selected = false;
              }
              $('.odplus_del' + i).css('display', 'none');
            }
          }

          // var table3 = new $.fn.dataTable.Api('.otable1');

          // var count = table3.rows({ selected: true }).count();
          // let selected = true;

          // if (count > 0) {
          //   table3.rows().deselect();
          //   selected = false;
          // }
          // else
          //   table3.rows().select();

          // $('th:first-child input', thead).prop("checked", selected);

        });
      },
      // }
    }

  }

  odatatableExport(val) {

    $('.scol_val').val(val);
    $('#odatatableExport3').modal('show');
    // $('#datatableExportBtn3').show();
    $('#datatableExportBtn3').html('');
    let j = val;
    if (j != "") {

      var table3 = new $.fn.dataTable.Api('.otable' + j);


      var buttons3 = new $.fn.dataTable.Buttons(table3, {
        dom: {
          button: {
            className: ''
          }
        },
        buttons: [
        {
          extend: 'csv',
          text: 'Export CSV',
          className: 'btn btn-info',
          exportOptions: {
            columns: '.selected',
            rows: function (idx, data, node) {
              var dt = new $.fn.dataTable.Api('.otable' + j);
              var selected = dt.rows({ selected: true }).indexes().toArray();
              if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                return true;

              return false;
            }
          },
          title: "KaizenCloud"
        },
        {
          extend: 'pdfHtml5',
          text: 'Export PDF',
          className: 'btn btn-info',
          orientation: 'landscape',
          pageSize: 'A3',
          exportOptions: {
            columns: '.selected',
            rows: function (idx, data, node) {
              var dt = new $.fn.dataTable.Api('.otable' + j);
              var selected = dt.rows({ selected: true }).indexes().toArray();

              if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                return true;


              return false;
            }
          },
          title: "KaizenCloud"
        },
        {
          extend: 'excel',
          text: 'Export Excel',
          className: 'btn btn-info',
          exportOptions: {
            columns: '.selected',
            rows: function (idx, data, node) {
              var dt = new $.fn.dataTable.Api('.otable' + j);
              var selected = dt.rows({ selected: true }).indexes().toArray();

              if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                return true;

              return false;
            }
          },
          title: "KaizenCloud"
        },
        {
          extend: 'print',
          text: 'Print',
          className: 'btn btn-info',
          exportOptions: {
            columns: '.selected',
            rows: function (idx, data, node) {
              var dt = new $.fn.dataTable.Api('.otable' + j);
              var selected = dt.rows({ selected: true }).indexes().toArray();

              if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                return true;

              return false;
            }
          },
          title: "KaizenCloud"
        },
        ], select: true
      }).container().appendTo($('#datatableExportBtn3'));
    }

    $('.scol_val').val('');


  }

  close() {
    $('#odatatableExport3').modal('hide');
    // $('#datatableExportBtn3').detach();
    $('#odatatableExport3').clear();
  }

  onchk(i,j)
  {
    // console.log($('#'+i).hasClass('selected'));

    $('.dmulval').val('');
    if ($('#'+i).hasClass('selected') == false) {
      $('.odplus_del' + j).css('display', 'inline-block');
      $('.dmulval').val(i);
    }
    else
    {
      $('.odplus_del' + j).css('display', 'none');
      $('.dmulval').val('');
    }     

  }

  datatableConfig3(): void {

    this.datatableColumns3();

    this.datatableOptions4 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs4,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table4 = new $.fn.dataTable.Api('#table4');

          var count = table4.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table4.rows().deselect();
            selected = false;
          }
          else
            table4.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table4 = new $.fn.dataTable.Api('#table4');
        // console.log(table4);
        table4
        .on('select deselect', function (e, dt, type, indexes) {

          var table4 = new $.fn.dataTable.Api('#table4');
          var selected = table4.rows({ selected: true }).indexes().toArray();

          if (selected.length === 0)
            self.deleteOption = false;
          else
            self.deleteOption = true;
        });

        var buttons3 = new $.fn.dataTable.Buttons(table4, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
          {
            extend: 'csv',
            text: this.doclang.exportCsv,
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table4');
                var selected = dt.rows({ selected: true }).indexes().toArray();
                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'pdfHtml5',
            text: this.doclang.exportPdf,
            className: 'btn btn-info',
            orientation: 'landscape',
            pageSize: 'A3',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table4');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;


                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'excel',
            text: this.doclang.exportExcel,
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table4');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'print',
            text: this.doclang.exportPrint,
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('#table4');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          ], select: true
        }).container().appendTo($('#datatableExportBtn4'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }

  datatableColumns(): void {

    this.datatableColsDefs1 = [
    {
      targets: 0,
      visible: false,
      orderable: false,
    },
    {
      targets: 1,
      orderable: false,
      className: 'select-checkbox'
    },
    ];

    this.datatableCols1 = [
    { id: 2, value: 'No.', isSelected: false },
    { id: 4, value: 'Description', isSelected: false },
    { id: 5, value: 'Guy', isSelected: false },
    { id: 6, value: 'Badge number', isSelected: false },
    { id: 7, value: 'Factory number', isSelected: false },
    { id: 8, value: 'Brand', isSelected: false },
    { id: 9, value: 'Template', isSelected: false },
    { id: 10, value: 'Date of commissioning', isSelected: false },
    { id: 11, value: 'Place of use', isSelected: false },
    { id: 12, value: 'Resposible', isSelected: false },
    { id: 13, value: 'Attachments', isSelected: false },
    { id: 14, value: 'Maintenance plans', isSelected: false },
    { id: 15, value: 'State of maintenance', isSelected: false },
    { id: 16, value: 'State', isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  datatableColumns1(): void {
    this.datatableColsDefs2 = [
    {
      targets: 0,
      visible: false,
      orderable: false,
    },
    {
      targets: 1,
      orderable: false,
      className: 'select-checkbox'
    },
    ];

    this.datatableCols2 = [
    { id: 2, value: this.exodlang.sno, isSelected: false },
    { id: 3, value: this.exodlang.dateofIntervention, isSelected: false },
    { id: 4, value: this.exodlang.description, isSelected: false },
    { id: 5, value: this.exodlang.performer, isSelected: false },
    { id: 6, value: this.exodlang.outcome, isSelected: false },
    { id: 7, value: this.exodlang.notes, isSelected: false },
    { id: 8, value: this.exodlang.cost, isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }


  datatableColumns2(): void {
    this.datatableColsDefs3 = [
    {
      targets: 0,
      visible: false,
      orderable: false,
    },
    {
      targets: 1,
      orderable: false,
      className: 'select-checkbox'
    },
    ];

    this.datatableCols3 = [
    { id: 2, value: this.odlang.sno, isSelected: false },
    { id: 3, value: this.odlang.executionDate, isSelected: false },
    { id: 4, value: this.odlang.description, isSelected: false },
    { id: 5, value: this.odlang.performer, isSelected: false },
    { id: 6, value: this.odlang.outcome, isSelected: false },
    { id: 7, value: this.odlang.notes, isSelected: false },
    { id: 8, value: this.odlang.option, isSelected: false },
    { id: 9, value: this.odlang.nextintervention, isSelected: false },
    { id: 10, value: this.odlang.referringDate, isSelected: false },
    { id: 11, value: this.odlang.cost, isSelected: false },
    { id: 12, value: this.odlang.attachments, isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  // datatableColumns3(): void{
  //   this.datatableColsDefs4 = [
  //   {
  //   targets: 0,
  //   visible: false,
  //   orderable: false,
  //   },
  //   {
  //   targets: 1,
  //   orderable: false,
  //   className: 'select-checkbox'
  //   },
  //   ];

  //   this.datatableCols3 = [
  //   { id: 2, value: 'No.', isSelected: false },
  //   { id: 3, value: 'Execution Date', isSelected: false },
  //   { id: 4, value: 'Description', isSelected: false },
  //   { id: 5, value: 'Performed By', isSelected: false },
  //   { id: 6, value: 'Outcome', isSelected: false },
  //   { id: 7, value: 'Note', isSelected: false },
  //   { id: 8, value: 'Option', isSelected: false },
  //   { id: 9, value: 'Upcoming Maintenance', isSelected: false },
  //   { id: 10, value: 'Reference Date', isSelected: false },
  //   { id: 11, value: 'Cost', isSelected: false },
  //   { id: 12, value: 'Attachments', isSelected: false }
  //   ];

  //   // this.datatableAddCols1 = [
  //   // { id: 2, value: 'Attachments', isSelected: false },
  //   // ];

  // }

  datatableColumns3(): void {
    this.datatableColsDefs4 = [
    {
      targets: 0,
      visible: false,
      orderable: false,
    },
    {
      targets: 1,
      orderable: false,
      className: 'select-checkbox'
    },
    ];

    this.datatableCols4 = [
    { id: 2, value: this.doclang.description, isSelected: false },
    { id: 3, value: this.doclang.date, isSelected: false },
    { id: 4, value: this.doclang.revision, isSelected: false },
    { id: 5, value: this.doclang.attachments, isSelected: false },
    { id: 6, value: this.doclang.status, isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }


  datatableFilter(): void {

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = data[4] || '';
      const filt2 = data[10] || '';
      const filt3 = data[11] || '';
      const filt4 = data[14] || '';

      var status = true;

      //if (this.filter1 && filt1 != this.filter1)
      //status = false;

      let a = this.filter1;
      // console.log(a);
      Object.keys(a).forEach(function (key) {
        if (a[key].item_id && filt1 != a[key].item_id)
          status = false;
        return status;
      });



      let aa = this.filter2;
      Object.keys(aa).forEach(function (key) {
        if (aa[key].item_id && filt2 != aa[key].item_id)
          status = false;
        return status;
      });


      let aaa = this.filter3;
      Object.keys(aaa).forEach(function (key) {
        if (aaa[key].item_id && filt3 != aaa[key].item_id)
          status = false;
        return status;
      });


      let aaaa = this.filter4;
      Object.keys(aaaa).forEach(function (key) {
        if (aaaa[key].item_id && filt4 != aaaa[key].item_id)
          status = false;
        return status;
      });


      return status;

    });

  }

  datatableFilterAction(): void {
    // console.log(DataTables.Api);
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.draw();

      // dtInstance.columns().every(function () {});


    });
  }

  FormBuild(): void {


    this.generalsForm = this.formBuilder.group({
      code: [''],
      type: [''],
      input: [''],
      class: [''],
      item_no: [''],
      job_no: [''],
      other: [''],
      desp: [''],
      start_date: [''],
      closed_by: [''],
      employee: [''],
      attachments: this.formBuilder.array([]),

    });

  }
  
  FormBuildUpdate(): void {

    let simages = this.course.attach.split(',');


    this.generalsForm.patchValue({
      code: this.course.code,
      type: this.course.type,
      input: this.course.input,
      class: this.course.classes,
      item_no: this.course.item_no,
      job_no: this.course.job_no,
      other: this.course.other,
      desp: this.course.desp,
      start_date: this.course.start_date,
      closed_by: this.course.closed_by,
      employee: this.course.resp_emp,
    });

    if (this.course.attach) {
      for (const uimage of simages) {
        this.attachments().push(new FormControl(uimage.split('/').pop()));
      }
    }

  }

  FormBuild1(): void {


    this.treatmentForm = this.formBuilder.group({
      problem_id: [this.id],
      treatment_id: [""],
      empList: [""],
      desp: ['', [Validators.required]],
      date_treatment: ['', [Validators.required]],
      cost: ['', [Validators.required]],
      externalReferences: this.formBuilder.array([this.newEmail()]),
      treatmentEmpBlck1: this.formBuilder.array([this.newEmployees()]),
      service_attach_exists: this.formBuilder.array([this.newAttachment1()]),
      service_attach_uploaded: this.formBuilder.array([]),


    });

    setTimeout(() => this.fileDesign(), 10);

    this.service_attach_exists().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

  }
  
  FormBuildUpdate1(): void {
    this.emptyEmail();
    this.emptyEmp();   

    this.treatmentForm.patchValue({
      desp: this.treatment.desp,
      empList: this.treatment.emp_id,
      treatment_id: this.treatment.id,
      date_treatment: this.treatment.treatment_date1,
      cost: this.treatment.cost,
    });


    if (this.treatment.stack_hokder_id) {
      let emails = this.treatment.stack_hokder_id.split(',');

      for (const email of emails) {
        this.externalReferences().push(this.newEmail(email));
      }
    }
    else {
      this.externalReferences().push(this.newEmail());
    }

    if (this.treatment.attachments) {
      let simages = this.treatment.attachments.split(',');

      for (const image of simages) {
        this.service_attach_uploaded().push(new FormControl(image.split('/').pop()));
      }
    }


    if (this.treatment.emp_id) {
      let emp_id = this.treatment.emp_id.split(',');

      for (const empval of emp_id) {
        this.treatmentEmpBlck1().push(this.newEmployees(empval));
      }
    }
    else {
      this.treatmentEmpBlck1().push(this.newEmployees());
    }
    

    
  }


  FormBuild2(): void {


    this.causeForm = this.formBuilder.group({
      cproblem_id: [this.id],
      cause_id: [''],
      cempList: [''],
      treatment_cause: ['', [Validators.required]],
      date_cause: ['', [Validators.required]],
      cost_cause: ['', [Validators.required]],
      cause_externalReferences: this.formBuilder.array([this.cnewEmail()]),
      causeEmpBlck1: this.formBuilder.array([this.cnewEmployees()]),
      cause_attach_exists: this.formBuilder.array([this.cnewAttachment1()]),
      cause_attach_uploaded: this.formBuilder.array([]),


    });

    setTimeout(() => this.fileDesign(), 10);

    this.cause_attach_exists().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

  }
  
  FormBuildUpdate2(): void {
    this.cemptyEmail();
    this.cemptyEmp();
    

    this.causeForm.patchValue({
      treatment_cause: this.cause.desp,
      cempList: this.cause.emp_id,
      cause_id: this.cause.id,
      date_cause: this.cause.date_cause,
      cost_cause: this.cause.cost,
    });


    if (this.cause.stack_holder_id) {
      let cemails = this.cause.stack_holder_id.split(',');

      for (const cemail of cemails) {
        this.cause_externalReferences().push(this.cnewEmail(cemail));
      }
    }
    else {
      this.cause_externalReferences().push(this.cnewEmail());
    }

    if (this.cause.attachments) {
      let simages = this.cause.attachments.split(',');

      for (const image of simages) {
        this.cause_attach_uploaded().push(new FormControl(image.split('/').pop()));
      }
    }


    if (this.cause.emp_id) {
      let emp_id = this.cause.emp_id.split(',');

      for (const empval of emp_id) {
        this.causeEmpBlck1().push(this.cnewEmployees(empval));
      }
    }
    else {
      this.causeEmpBlck1().push(this.cnewEmployees());
    }
    
  }


  FormBuild3(): void {


    this.correctiveForm = this.formBuilder.group({
      caproblem_id: [this.id],
      corrective_id: [''],
      caempList: [''],
      treatment_correct: ['', [Validators.required]],
      date_correct: ['', [Validators.required]],
      cost_correct: ['', [Validators.required]],
      corr_externalReferences: this.formBuilder.array([this.canewEmail()]),
      correctiveEmpBlck1: this.formBuilder.array([this.canewEmployees()]),
      corr_attach_exists: this.formBuilder.array([this.canewAttachment1()]),
      corr_attach_uploaded: this.formBuilder.array([]),


    });

    setTimeout(() => this.fileDesign(), 10);

    this.corr_attach_exists().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

  }
  
  FormBuildUpdate3(): void {
    this.caemptyEmail();
    this.caemptyEmp();
    

    this.correctiveForm.patchValue({
      treatment_correct: this.corrective.desp,
      caempList: this.corrective.emp_id,
      corrective_id: this.corrective.id,
      date_correct: this.corrective.date_corrective,
      cost_correct: this.corrective.cost,
    });


    if (this.corrective.stack_holder_id) {
      let cemails = this.corrective.stack_holder_id.split(',');

      for (const cemail of cemails) {
        this.corr_externalReferences().push(this.canewEmail(cemail));
      }
    }
    else {
      this.corr_externalReferences().push(this.canewEmail());
    }

    if (this.corrective.attachments) {
      let simages = this.corrective.attachments.split(',');

      for (const image of simages) {
        this.corr_attach_uploaded().push(new FormControl(image.split('/').pop()));
      }
    }


    if (this.corrective.emp_id) {
      let emp_id = this.corrective.emp_id.split(',');

      for (const empval of emp_id) {
        this.correctiveEmpBlck1().push(this.canewEmployees(empval));
      }
    }
    else {
      this.correctiveEmpBlck1().push(this.canewEmployees());
    }
    
  }


  FormBuild4(): void {


    this.checkForm = this.formBuilder.group({
      ceaproblem_id: [this.id],
      check_id: [''],
      ceempList: [''],
      treatment_check: ['', [Validators.required]],
      date_check: ['', [Validators.required]],
      cost_check: ['', [Validators.required]],
      check_externalReferences: this.formBuilder.array([this.cenewEmail()]),
      checkEmpBlck1: this.formBuilder.array([this.cenewEmployees()]),
      check_attach_exists: this.formBuilder.array([this.cenewAttachment1()]),
      check_attach_uploaded: this.formBuilder.array([]),


    });

    setTimeout(() => this.fileDesign(), 10);

    this.check_attach_exists().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

  }
  
  FormBuildUpdate4(): void {
    this.ceemptyEmail();
    this.ceemptyEmp();
    

    this.checkForm.patchValue({
      treatment_check: this.check.desp,
      ceempList: this.check.emp_id,
      check_id: this.check.id,
      date_check: this.check.date_check,
      cost_check: this.check.cost,
    });


    if (this.check.stack_holder_id) {
      let cemails = this.check.stack_holder_id.split(',');

      for (const cemail of cemails) {
        this.check_externalReferences().push(this.cenewEmail(cemail));
      }
    }
    else {
      this.check_externalReferences().push(this.cenewEmail());
    }

    if (this.check.attachments) {
      let simages = this.check.attachments.split(',');

      for (const image of simages) {
        this.check_attach_uploaded().push(new FormControl(image.split('/').pop()));
      }
    }


    if (this.check.emp_id) {
      let emp_id = this.check.emp_id.split(',');

      for (const empval of emp_id) {
        this.checkEmpBlck1().push(this.cenewEmployees(empval));
      }
    }
    else {
      this.checkEmpBlck1().push(this.cenewEmployees());
    }
    
  }


  FormBuild5(): void {


    this.reportForm = this.formBuilder.group({
      rcode: [''],
      rtype: [''],
      rinput: [''],
      rclass: [''],
      ritem_no: [''],
      rjob_no: [''],
      rother: [''],
      rdesp: [''],
      rstart_date: [''],
      rclosed_by: [''],
      remployee: [''],
      employee_email: [''],
      employee_phone: [''],
      gattachments: this.formBuilder.array([]),


    });

    setTimeout(() => this.fileDesign(), 10);

    this.service_attach_exists().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

  }
  
  FormBuildUpdate5(): void {

    let simages = this.course.attach.split(',');


    this.reportForm.patchValue({
      rcode: this.rcourse.code,
      rtype: this.rcourse.type,
      rinput: this.rcourse.input,
      rclass: this.rcourse.class,
      ritem_no: this.rcourse.item_no,
      rjob_no: this.rcourse.job_no,
      rother: this.rcourse.other,
      rdesp: this.rcourse.desp,
      rstart_date: this.rcourse.start_date,
      rclosed_by: this.rcourse.closed_by,
      remployee: this.rcourse.resp_emp,
      employee_email: this.rcourse.employee_email,
      employee_phone: this.rcourse.employee_phone,
    });
    
    if (this.course.attach) {
      for (const uimage of simages) {
        this.gattachments().push(new FormControl(uimage.split('/').pop()));
      }
    }
    
  }



  FormBuild6(): void {


    this.reportTreatmentForm = this.formBuilder.group({
      tdesp: [''],
      tdate_treatment: [''],
      tcost: [''],
      tfigure: [''],
      texternalReferences: this.formBuilder.array(['']),
      tattachments: this.formBuilder.array([]),

    });

    setTimeout(() => this.fileDesign(), 10);

    this.service_attach_exists().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

  }
  
  FormBuildUpdate6(): void {


    this.reportTreatmentForm.patchValue({
      tdesp: this.rtreatment.desp,
      tdate_treatment: this.rtreatment.treatment_date1,
      tcost: this.rtreatment.cost,     
      tfigure: this.rtreatment.temp_name,     

    });
    if (this.rtreatment.attachments) {
      let simages = this.rtreatment.attachments.split(',');

      for (const uimage of simages) {
        this.tattachments().push(new FormControl(uimage.split('/').pop()));
      }
    }
    
  }


  FormBuild7(): void {


    this.reportCauseForm = this.formBuilder.group({
      tcause: [''],
      tcdate_treatment: [''],
      tccost: [''],
      cfigure: [''],
      cattachments: this.formBuilder.array([]),

    });

  }
  
  FormBuildUpdate7(): void {


    this.reportCauseForm.patchValue({
      tcause: this.rphase3.desp,
      tcdate_treatment: this.rphase3.date_cause,
      tccost: this.rphase3.cost,
      cfigure: this.rphase3.cemp_name,    

    });

    if (this.rphase3.attachments) {
      let scimages = this.rphase3.attachments.split(',');

      for (const uimage of scimages) {
        this.cattachments().push(new FormControl(uimage.split('/').pop()));
      }
    }
    
  }



  FormBuild8(): void {


    this.reportCorrectiveForm = this.formBuilder.group({
      tcorrdesp: [''],
      tcfdate_treatment: [''],
      tcfcost: [''],
      ceattachments: this.formBuilder.array([]),
      cefigure:  [''],

    });

  }
  
  FormBuildUpdate8(): void {

    this.reportCorrectiveForm.patchValue({
      tcorrdesp: this.rphase4.desp,
      tcfdate_treatment: this.rphase4.date_corrective,
      tcfcost: this.rphase4.cost,
      cefigure: this.rphase4.ceemp_name,
      

    });

    if (this.rphase4.attachments) {
      let sceimages = this.rphase4.attachments.split(',');

      for (const uimage of sceimages) {
        this.ceattachments().push(new FormControl(uimage.split('/').pop()));
      }
    }
  }



  FormBuild9(): void {


    this.reportFinalForm = this.formBuilder.group({
      tfinalDesp: [''],
      tfdate_treatment: [''],
      tfcost: [''],
      tffigure: [''],
      cfattachments: this.formBuilder.array([]),

    });

  }
  
  FormBuildUpdate9(): void {

    this.reportFinalForm.patchValue({
      tfinalDesp: this.rphase5.desp,
      tfdate_treatment: this.rphase5.date_check,
      tfcost: this.rphase5.cost,
      tffigure: this.rphase5.tfemp_name,
      

    });

    if (this.rphase5.attachments) {
      let scfimages = this.rphase5.attachments.split(',');

      for (const uimage of scfimages) {
        this.cfattachments().push(new FormControl(uimage.split('/').pop()));
      }
    }
  }

  
  cause_attach_exists(): FormArray {
    return this.causeForm.get('cause_attach_exists') as FormArray;
  };

  caddAttachment(): void {
    this.cause_attach_exists().push(this.cnewAttachment1());
  }

  cremoveAttachment(i: number) {
    this.cause_attach_exists().removeAt(i);
  }


  corr_attach_exists(): FormArray {
    return this.correctiveForm.get('corr_attach_exists') as FormArray;
  };

  check_attach_exists(): FormArray {
    return this.checkForm.get('check_attach_exists') as FormArray;
  };

  
  caaddAttachment(): void {
    this.corr_attach_exists().push(this.cnewAttachment1());
  }
  
  caremoveAttachment(i: number) {
    this.corr_attach_exists().removeAt(i);
  }

  ceaddAttachment(): void {
    this.check_attach_exists().push(this.cnewAttachment1());
  }
  
  ceremoveAttachment(i: number) {
    this.check_attach_exists().removeAt(i);
  }

  

  service_attach_exists(): FormArray {
    return this.treatmentForm.get('service_attach_exists') as FormArray;
  };

  addAttachment(): void {
    this.service_attach_exists().push(this.newAttachment1());
  }

  removeAttachment(i: number) {
    this.service_attach_exists().removeAt(i);
  }

  externalReferences() : FormArray {
    return this.treatmentForm.get("externalReferences") as FormArray
  }


  cause_externalReferences() : FormArray {
    return this.causeForm.get("cause_externalReferences") as FormArray
  }

  corr_externalReferences() : FormArray {
    return this.correctiveForm.get("corr_externalReferences") as FormArray
  }

  check_externalReferences() : FormArray {
    return this.checkForm.get("check_externalReferences") as FormArray
  }

  treatmentEmpBlck1() : FormArray {
    return this.treatmentForm.get("treatmentEmpBlck1") as FormArray
  }

  causeEmpBlck1() : FormArray {
    return this.causeForm.get("causeEmpBlck1") as FormArray
  }

  correctiveEmpBlck1() : FormArray {
    return this.correctiveForm.get("correctiveEmpBlck1") as FormArray
  }

  checkEmpBlck1() : FormArray {
    return this.checkForm.get("checkEmpBlck1") as FormArray
  }
  
  

  newEmail(data = ''): FormControl {
    return new FormControl(data, Validators.required);
  }


  cnewEmail(data = ''): FormControl {
    return new FormControl(data, Validators.required);
  }

  canewEmail(data = ''): FormControl {
    return new FormControl(data, Validators.required);
  }


  cenewEmail(data = ''): FormControl {
    return new FormControl(data, Validators.required);
  }


  newEmployees(data = ''): FormControl {
    return new FormControl(data, [Validators.required]);
  }

  cnewEmployees(data = ''): FormControl {
    return new FormControl(data, [Validators.required]);
  }

  canewEmployees(data = ''): FormControl {
    return new FormControl(data, [Validators.required]);
  }


  cenewEmployees(data = ''): FormControl {
    return new FormControl(data, [Validators.required]);
  }


  addEmail() {
    this.externalReferences().push(this.newEmail());
  }

  removeEmail(i:number) {
    this.externalReferences().removeAt(i);
  }

  emptyEmail() {
    while (this.externalReferences().controls.length > 0) {
      this.externalReferences().removeAt(0);
    }
  }

  caddEmail() {
    this.cause_externalReferences().push(this.newEmail());
  }

  cremoveEmail(i:number) {
    this.cause_externalReferences().removeAt(i);
  }


  caaddEmail() {
    this.corr_externalReferences().push(this.canewEmail());
  }

  caremoveEmail(i:number) {
    this.corr_externalReferences().removeAt(i);
  }

  ceaddEmail() {
    this.check_externalReferences().push(this.canewEmail());
  }

  ceremoveEmail(i:number) {
    this.check_externalReferences().removeAt(i);
  }



  cemptyEmail() {
    while (this.cause_externalReferences().controls.length > 0) {
      this.cause_externalReferences().removeAt(0);
    }
  }

  caemptyEmail() {
    while (this.corr_externalReferences().controls.length > 0) {
      this.corr_externalReferences().removeAt(0);
    }
  }

  ceemptyEmail() {
    while (this.check_externalReferences().controls.length > 0) {
      this.check_externalReferences().removeAt(0);
    }
  }

  emptyEmp() {
    while (this.treatmentEmpBlck1().controls.length > 0) {
      this.treatmentEmpBlck1().removeAt(0);
    }
  }

  addEmployees() {
    this.treatmentEmpBlck1().push(this.newEmployees());
  }

  removeEmail1(i: number) {
    // console.log(i);
    this.treatmentEmpBlck1().removeAt(i);
  }

  emptyEmail1() {
    while (this.treatmentEmpBlck1().controls.length > 0) {
      this.treatmentEmpBlck1().removeAt(0);
    }
  }



  cemptyEmp() {
    while (this.causeEmpBlck1().controls.length > 0) {
      this.causeEmpBlck1().removeAt(0);
    }
  }

  caemptyEmp() {
    while (this.correctiveEmpBlck1().controls.length > 0) {
      this.correctiveEmpBlck1().removeAt(0);
    }
  }

  ceemptyEmp() {
    while (this.checkEmpBlck1().controls.length > 0) {
      this.checkEmpBlck1().removeAt(0);
    }
  }

  caddEmployees() {
    this.causeEmpBlck1().push(this.cnewEmployees());
  }

  cremoveEmail1(i:number) {
    this.causeEmpBlck1().removeAt(i);
  }

  cemptyEmail1() {
    while (this.causeEmpBlck1().controls.length > 0) {
      this.causeEmpBlck1().removeAt(0);
    }
  }


  caaddEmployees() {
    this.correctiveEmpBlck1().push(this.canewEmployees());
  }

  caremoveEmail1(i:number) {
    this.correctiveEmpBlck1().removeAt(i);
  }

  caemptyEmail1() {
    while (this.correctiveEmpBlck1().controls.length > 0) {
      this.correctiveEmpBlck1().removeAt(0);
    }
  }

  ceaddEmployees() {
    this.checkEmpBlck1().push(this.canewEmployees());
  }

  ceremoveEmail1(i:number) {
    this.checkEmpBlck1().removeAt(i);
  }

  ceemptyEmail1() {
    while (this.checkEmpBlck1().controls.length > 0) {
      this.checkEmpBlck1().removeAt(0);
    }
  }



  newAttachment1(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }


  cnewAttachment1(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  canewAttachment1(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  cenewAttachment1(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  
  attachments(): FormArray {
    return this.generalsForm.get('attachments') as FormArray;
  };

  gattachments(): FormArray {
    return this.reportForm.get('gattachments') as FormArray;
  };


  tattachments(): FormArray {
    return this.reportTreatmentForm.get('tattachments') as FormArray;
  };


  cattachments(): FormArray {
    return this.reportCauseForm.get('cattachments') as FormArray;
  };

  ceattachments(): FormArray {
    return this.reportCorrectiveForm.get('ceattachments') as FormArray;
  };

  cfattachments(): FormArray {
    return this.reportFinalForm.get('cfattachments') as FormArray;
  };

  removeAttachmentUploaded1(i: number) {
    this.attachments().removeAt(i);
  }


  service_attach_uploaded(): FormArray {
    return this.treatmentForm.get('service_attach_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.service_attach_uploaded().removeAt(i);
  }



  cause_attach_uploaded(): FormArray {
    return this.causeForm.get('cause_attach_uploaded') as FormArray;
  };

  cremoveAttachmentUploaded(i: number) {
    this.cause_attach_uploaded().removeAt(i);
  }

  corr_attach_uploaded(): FormArray {
    return this.correctiveForm.get('corr_attach_uploaded') as FormArray;
  };

  caremoveAttachmentUploaded(i: number) {
    this.corr_attach_uploaded().removeAt(i);
  }

  check_attach_uploaded(): FormArray {
    return this.checkForm.get('check_attach_uploaded') as FormArray;
  };

  ceremoveAttachmentUploaded(i: number) {
    this.check_attach_uploaded().removeAt(i);
  }




  public selectAttachment1(event: any, index) {

    this.treatmentForm.value.service_attach_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.treatmentForm.value.service_attach_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }

  public selectAttachment2(event: any, index) {

    this.causeForm.value.cause_attach_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.causeForm.value.cause_attach_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }

  public selectAttachment3(event: any, index) {

    this.correctiveForm.value.corr_attach_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.correctiveForm.value.corr_attach_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  public selectAttachment4(event: any, index) {

    this.checkForm.value.check_attach_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.checkForm.value.check_attach_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }


  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }



  getData() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      
     this.selectedTab = 'treatment';

      this.problemSolvingService.generalList(this.id)
      .subscribe(
        (res) => {
          this.lang = this.problemSolvingService.listLang(res);
            // console.log(this.lang); teturn false; 
            this.course = res.data.course;
            this.treatment = res.data.treatment;

            this.FormBuildUpdate();
          }
          );
      this.FormBuild();

    });
  }

  tab1Actions() {
    this.route.params.subscribe(params => {
      this.id = params.id;
      // localStorage.setItem('selectedTab', 'treatment');

           this.selectedTab = 'treatment';



      this.problemSolvingService.generalList(this.id)
      .subscribe(
        (res) => {
          this.lang = this.problemSolvingService.listLang(res);
          this.treatment = res.data.treatment;
          this.emp_list = '1';
          this.emp_list1 = res.data.emp_list1;
          this.treatment_settings = res.data.treatment_settings;

          this.FormBuildUpdate1();


        }
        );
      // this.generalLang = this.lang;
      this.treatmentFormErrorMsg = {
        'desp': [{ type: 'required', message: 'this field is required' }],
        'date_treatment': [{ type: 'required', message: 'this field is required' }],
        'cost': [{ type: 'required', message: 'this field is required' }],
        'treatmentEmpBlck1': [{ type: 'required', message: 'this field is required' }],      'externalReferences': [
        { type: 'required', message: 'this field is required' }
        ],
      }


      this.FormBuild1();
      

      

    });
  }

  tab2Actions() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.selectedTab = localStorage.getItem('selectedTab');

      // console.log(this.selectedTab);

      this.problemSolvingService.generalList(this.id)
      .subscribe(
        (res) => {
          this.lang = this.problemSolvingService.listLang(res);
          this.cause = res.data.cause;
          this.emp_list = res.data.emp_list;
          this.emp_list1 = res.data.emp_list1;
          this.cause_settings = res.data.cause_settings;
          this.cause_analysis = res.data.cause_analysis;

          this.FormBuildUpdate2();            
        }
        );
      this.causeFormErrorMsg = {
        'treatment_cause': [{ type: 'required', message: 'this field is required' }],
        'date_cause': [{ type: 'required', message: 'this field is required' }],
        'cost_cause': [{ type: 'required', message: 'this field is required' }],
        'causeEmpBlck1': [{ type: 'required', message: 'this field is required' }],      'cause_externalReferences': [
        { type: 'required', message: 'this field is required' }
        ],
      }
      
      
      this.FormBuild2();

    });
  }

  tab3Actions() {
    this.route.params.subscribe(params => {
      this.id = params.id;

     this.selectedTab = localStorage.getItem('selectedTab');


      this.problemSolvingService.generalList(this.id)
      .subscribe(
        (res) => {
          this.lang = this.problemSolvingService.listLang(res);
          this.corrective = res.data.corrective;
          this.emp_list = res.data.emp_list;
          this.emp_list1 = res.data.emp_list1;
          this.corrective_settings = res.data.corrective_settings;
          this.corrective_actions = res.data.corrective_actions;


          this.FormBuildUpdate3();            
        }
        );
      this.correctiveFormErrorMsg = {
        'treatment_correct': [{ type: 'required', message: 'this field is required' }],
        'date_correct': [{ type: 'required', message: 'this field is required' }],
        'cost_correct': [{ type: 'required', message: 'this field is required' }],
        'correctiveEmpBlck1': [{ type: 'required', message: 'this field is required' }],      'corr_externalReferences': [
        { type: 'required', message: 'this field is required' }
        ],
      }
      
      
      this.FormBuild3();

    });
  }


  tab4Actions() {
    this.route.params.subscribe(params => {
      this.id = params.id;

     this.selectedTab = localStorage.getItem('selectedTab');

      this.problemSolvingService.generalList(this.id)
      .subscribe(
        (res) => {
          this.lang = this.problemSolvingService.listLang(res);
          this.check = res.data.check;
          this.emp_list = res.data.emp_list;
          this.emp_list1 = res.data.emp_list1;
          this.check_settings = res.data.check_settings;
          this.check_effectiveness = res.data.check_effectiveness;

          this.FormBuildUpdate4();            
        }
        );
      this.checkFormErrorMsg = {
        'treatment_check': [{ type: 'required', message: 'this field is required' }],
        'date_check': [{ type: 'required', message: 'this field is required' }],
        'cost_check': [{ type: 'required', message: 'this field is required' }],
        'checkEmpBlck1': [{ type: 'required', message: 'this field is required' }],      'check_externalReferences': [
        { type: 'required', message: 'this field is required' }
        ],
      }
      
      
      this.FormBuild4();

    });
  }


  tab5Actions() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.problemSolvingService.generalList(this.id)
      .subscribe(
        (res) => {
          this.lang = this.problemSolvingService.listLang(res);
              // console.log(this.lang); teturn false; 
              this.rcourse = res.data.course;
              this.rtreatment = res.data.treatment;
              this.rphase3 = res.data.cause;
              this.rphase4 = res.data.corrective;
              this.rphase5 = res.data.check;
              this.get_action_data = res.data.get_action_data;

              this.FormBuildUpdate5();
              this.FormBuildUpdate6();
              this.FormBuildUpdate7();
              this.FormBuildUpdate8();
              this.FormBuildUpdate9();

            }
            );
      this.FormBuild5();
      this.FormBuild6();
      this.FormBuild7();
      this.FormBuild8();
      this.FormBuild9();

    });
  }



  // tab3Actions(): void {

  //   this.route.params.subscribe(params => {
  //     this.id = params.id;

  //     // console.log(this.data);

  //     this.servicingService.ordinaryData(this.id)
  //       .subscribe(
  //         (res) => {
  //           this.odlang = this.servicingService.ServicingOrdinaryLang(res);
  //           // this.ordinary_data = res.data.planvals.ordata;
  //           this.planvals = res.data.planvals;

  //           this.cnt = this.planvals.length;

  //           // console.log(count);

  //           //load datatable
  //           this.datatableConfig2();


  //         }
  //       );
  //   });


  // }

  // tab4Actions(): void {

  //   this.route.params.subscribe(params => {
  //     this.id = params.id;

  //     // console.log(params);

  //     this.servicingService.documentsData()
  //       .subscribe(
  //         (res) => {
  //           this.doclang = this.servicingService.ServicingDocumentsLang(res);
  //           this.documents_data = res.data.sdoc_data;
  //           // console.log(this.documents_data);
  //           //load datatable
  //           this.datatableConfig3();
  //           this.datatableFilter();
  //         }
  //       );
  //   });



  // }

  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
    .then(() => {
      this.router.navigate([AppFrontRoutes.VIEW_PROBLEM_DETAILS+'/'+this.id]);
    });
  }

  success(msg: any) {

    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    // this.redirect();

    this.router.navigateByUrl('/test', { skipLocationChange: true })
    .then(() => {
      this.router.navigate([AppFrontRoutes.VIEW_PROBLEM_DETAILS+'/'+this.id]);
    });
    setTimeout(() => {
      window.location.reload();
    }, 3000);


  }


  mulitSelect() {
    this.dropdownList = [
    { item_id: this.lang.vehicle, item_text: this.lang.vehicle },
    { item_id: this.lang.plant, item_text: this.lang.plant },
    { item_id: this.lang.machine, item_text: this.lang.machine },
    { item_id: this.lang.fireDispenser, item_text: this.lang.fireDispenser },
    { item_id: this.lang.firstServiceDevice, item_text: this.lang.firstServiceDevice },
    { item_id: this.lang.individualProtectionDevice, item_text: this.lang.individualProtectionDevice },
    { item_id: this.lang.safetyEquipment, item_text: this.lang.safetyEquipment }
    ];


    let that = this;

    let loca = this.lang.locations;
    Object.keys(loca).forEach(function (key) {
      // console.log(loca[key]);   
      that.dropdownList1.push({ item_id: loca[key], item_text: loca[key] },)
    });


    let loca1 = this.lang.responsibles;
    Object.keys(loca1).forEach(function (key) {
      // console.log(loca1[key]);   
      that.dropdownList2.push({ item_id: loca1[key], item_text: loca1[key] },)
    });


    this.dropdownList3 = [
    { item_id: this.lang.active, item_text: this.lang.active },
    { item_id: this.lang.decommissioned, item_text: this.lang.decommissioned },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };


  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

  }



  export2_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      this.datatableCols2[i].isSelected = selected;
    }
    this.datatable_export2_choose_column();

  }

  export2_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].id == id)
        this.datatableCols2[i].isSelected = selected;
    }

    this.datatable_export2_choose_column();

  }

  datatable_export2_choose_column(): void {

    var table1_name = '#table2';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].isSelected)
        table1.column(parseInt(this.datatableCols2[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols2[i].id)).deselect();
    }

  }


  export3_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      this.datatableCols3[i].isSelected = selected;
    }
    this.datatable_export3_choose_column();

  }

  export3_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      if (this.datatableCols3[i].id == id)
        this.datatableCols3[i].isSelected = selected;
    }

    this.datatable_export3_choose_column();

  }

  datatable_export3_choose_column(): void {

    let vcnt = $('th:first-child input').val();
    // console.log(vcnt);

    for (let j = 1; j <= vcnt; j++) {

      var table1_name = '.otable' + j;
      var table1 = new $.fn.dataTable.Api(table1_name);

      for (var i = 0; i < this.datatableCols3.length; i++) {
        if (this.datatableCols3[i].isSelected)
          table1.column(parseInt(this.datatableCols3[i].id)).select();
        else
          table1.column(parseInt(this.datatableCols3[i].id)).deselect();
      }
    }

  }




  export4_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      this.datatableCols4[i].isSelected = selected;
    }
    this.datatable_export4_choose_column();

  }

  export4_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].id == id)
        this.datatableCols4[i].isSelected = selected;
    }

    this.datatable_export4_choose_column();

  }

  datatable_export4_choose_column(): void {

    var table1_name = '#table4';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].isSelected)
        table1.column(parseInt(this.datatableCols4[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols4[i].id)).deselect();
    }

  }



  // addServicing() {

  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // }

  setPageView(view) {
    this.pageView = view;
  }

  // addExtra() {

  //   this.addExtraModel = this.modalService.show(ServicingExtraComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // }




  // addMaintenance(SID, SPID, OID) {
  //   this.addMaintenanceModel = this.modalService.show(ServicingMaintenance, { class: 'modal-lgs', initialState: { 'SID': SID, 'SPID': SPID, 'OID': OID, 'action': 'modify', 'langs': this.lang } });
  // }

  // editServicing(ID) {
  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang } });
  // }


  viewProblemSolving() {

    this.viewProblemSolvingModel = this.modalService.show(ViewProblemSolvingComponent, { class: 'modal-lgs', initialState: { 'langs': this.lang } });

  }



  delete(ID) {

    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
    .subscribe(
      (confirmed) => {

        if (!confirmed)
          return;

        this.problemSolvingService.viewDelete(ID)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });

      });
  }


  mail(ID) {

    this.problemSolvingService.sendMail(ID)
    .subscribe(
      (res) => {
        if (res.status)
          this.success(res.msg);
        else
          this.error(res.msg);
      });


  }
  


  pdfexport(ID) {

    this.problemSolvingService.pdfexport(ID)
    .subscribe(
      (res) => {
        if (res.status)
          this.success(res.msg);
        else
          this.error(res.msg);
      });


  }


  delete_extraordinary(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Do you want to delete this?')
    .subscribe(
      (confirmed) => {

        if (!confirmed)
          return;

        this.servicingService.delete_extraordinary(ID)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });

      });
  }

  delete_ordinary(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Do you want to delete this?')
    .subscribe(
      (confirmed) => {

        if (!confirmed)
          return;

        this.servicingService.delete_ordinary(ID)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });

      });
  }


  delete_sdocuments(ID) {

    this.confirmationDialogService.confirm('Servicing Documents Delete Confirmation', 'Do you want to delete this?')
    .subscribe(
      (confirmed) => {

        if (!confirmed)
          return;

        this.servicingService.delete_sdocuments(ID)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });

      });
  }


  turnoff(sID, pid, rid) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Are you sure to deactivate?')
    .subscribe(
      (confirmed) => {

        if (!confirmed)
          return;

        this.servicingService.turnoff(sID, pid, rid)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });
        $("#sactivate_plan").modal("hide");
      });
  }

  activate_plan(pid, sId) {

    $("#plan_id_forcd").val(pid);
    $("#pservice_id").val(sId);
    $("#sactivate_plan").modal("show");
  }

  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
    .subscribe(
      (confirmed) => {

        if (!confirmed)
          return;

        this.servicingService.multiDelete(selectedRows)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });
      });
  }



  multiDelete1() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
    .subscribe(
      (confirmed) => {
        if (!confirmed)
          return;

        this.servicingService.delete_mextraordinary(selectedRows)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });
      });
  }


  doc_multiDelete() {

    var table4 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table4.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
    .subscribe(
      (confirmed) => {
        if (!confirmed)
          return;

        this.servicingService.delete_msdocuments(selectedRows)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });
      });
  }


  deleteMultiOrdinary() {
    // console.log('sss1');
    var vcnt = $('th:first-child input').val();
    var oid = $('#dmulval').val();

    if (oid != "") {
      // console.log(oid);
      this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.deleteMultiOrdinary(oid)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
            });
        });
      
      
    }
    else {
      for (let i = 1; i <= vcnt; i++) {
        // console.log(i);
        if ($('.chk' + i).is(":checked")) {
          var table3 = new $.fn.dataTable.Api('.otable' + i);
          // var table3 = new $.fn.dataTable.Api('.otable3');
          let selectedRows = table3.rows({ selected: true }).ids().toArray();

          this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
          .subscribe(
            (confirmed) => {

              if (!confirmed)
                return;

              this.servicingService.deleteMultiOrdinary(selectedRows)
              .subscribe(
                (res) => {
                  if (res.status)
                    this.success(res.msg);
                  else
                    this.error(res.msg);
                });
            });
        }
      }
    }

  }


  multiDuplicate() {

    var table2 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table2.rows({ selected: true }).ids().toArray();


    this.servicingService.multiExtraDuplicate(selectedRows)
    .subscribe(
      (res) => {
        if (res.status)
          this.success(res.msg);
        else
          this.error(res.msg);
      });

  }

  multiOrdDuplicate() {

    let vcnt = $('th:first-child input').val();
    for (let i = 1; i <= vcnt; i++) {
      if ($('.chk' + i).is(":checked")) {
        var table3 = new $.fn.dataTable.Api('.otable' + i);
        let selectedRows = table3.rows({ selected: true }).ids().toArray();

        this.servicingService.multiOrdDuplicate(selectedRows)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });
      }
    }

  }

  doc_multiDuplicate() {

    var table3 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table3.rows({ selected: true }).ids().toArray();


    this.servicingService.doc_multiDuplicate(selectedRows)
    .subscribe(
      (res) => {
        if (res.status)
          this.success(res.msg);
        else
          this.error(res.msg);
      });

  }

  duplicate(ID) {

    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure you duplicate this line?')
    .subscribe(
      (confirmed) => {

        if (!confirmed)
          return;

        this.servicingService.duplicate(ID)
        .subscribe(
          (res) => {
            if (res.status)
              this.success(res.msg);
            else
              this.error(res.msg);
          });

      });


  }




  onPhotoPickerChange(ev) {
    let file = ev.target.files[0];
    file = ev.target.files[0];

    // console.log(file.name);
    let file_name = file.name;
    if (!(/\.(csv)$/i).test(file_name)) {
      alert('Please upload valid excel file_name .csv only.');
      $('#file').val('');
    }
    else {
      let fs = new FileReader();
      fs.onload = (res: any) => {
        this.getPhotoBase64 = res.target.result;
        $('#profile_input').val('');
      };
      fs.readAsDataURL(file);
    }
  }

  // treatment_unlock(id:any,pid:any)
  // {

  //   this.confirmationDialogService.confirm('User Confirmation', 'Do you want to change this?')
  //   .subscribe(
  //     (confirmed) => {

  //       if (!confirmed)
  //         return;

  //   this.problemSolvingService.treatment_unlock(pid, id).subscribe(
  //     res => {

  //     });
  //   });
  // }



  treatment_unlock(id:any,pid:any) {

    this.confirmationDialogService.confirm('Unlock', 'Do you want to change this?')
    .subscribe(
      (confirmed) => {

        if (!confirmed)
          return;

        this.problemSolvingService.treatment_unlock(pid, id)
        .subscribe(
          (res) => {
                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);

                this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.VIEW_PROBLEM_DETAILS+'/'+this.id]);
                });

                setTimeout(() => {
                  window.location.reload();
                }, 3000);
                
                
              });

      });


  }



  onclick() {
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    if (profileImage != undefined && $('#file').val() != '') {
      this.servicingService.updateImport(profileImage)
      .subscribe(
        (res) => {
          if (res.status) {
              // this.success(res.msg);
              // $("#datatableExport4").modal("hide");
              this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.Servicing_List]);
              });
              setTimeout(() => {
                window.location.reload();
              }, 3000);

            }
            else {
              // this.error(res.msg);
              // $("#datatableExport4").modal("hide");
              this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.Servicing_List]);
              });
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          });
    }
  }


  onSubmit(data) {


    this.treatmentFormSubmitted = true;

    if (this.treatmentForm.invalid)
      return;
    
    this.problemSolvingService.update_treatment(this.treatmentForm.value).subscribe(
      res => {

        // $("#treatment_un").css('display','block');
        // $("#treatment_submit").css('display', 'none');
        
        // return false;


        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          // this.bsModalRef.hide();
          
          this.router.navigateByUrl('/test', { skipLocationChange: true })
          .then(() => {
            this.router.navigate([AppFrontRoutes.VIEW_PROBLEM_DETAILS+'/'+this.id]);
          });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          // this.bsModalRef.hide();
        }

        this.treatment = '#treatment';
        localStorage.setItem('selectedTab', 'treatment');


      }
      );
  }


  onCauseSubmit(data) {


    this.causeFormSubmitted = true;

    if (this.causeForm.invalid)
      return;
    
    this.problemSolvingService.update_cause(this.causeForm.value).subscribe(
      res => {



        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          // this.bsModalRef.hide();
          
          this.router.navigateByUrl('/test', { skipLocationChange: true })
          .then(() => {
            this.router.navigate([AppFrontRoutes.VIEW_PROBLEM_DETAILS+'/'+this.id]);
          });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
        }

        this.cause_analysis = '#cause_analysis';
        localStorage.setItem('selectedTab', 'cause');


      }
      );
  }

  onCorrectSubmit(data) {


    this.correctiveFormSubmitted = true;

    if (this.correctiveForm.invalid)
      return;
    
    this.problemSolvingService.update_corrective(this.correctiveForm.value).subscribe(
      res => {


        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          // this.bsModalRef.hide();
          
          this.router.navigateByUrl('/test', { skipLocationChange: true })
          .then(() => {
            this.router.navigate([AppFrontRoutes.VIEW_PROBLEM_DETAILS+'/'+this.id]);
          });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          // this.bsModalRef.hide();
        }

        this.corrective_actions = '#corrective_actions';
        localStorage.setItem('selectedTab', 'corrective');


      }
      );
  }

  onCheckSubmit(data) {


    this.checkFormSubmitted = true;

    if (this.checkForm.invalid)
      return;
    
    this.problemSolvingService.update_check(this.checkForm.value).subscribe(
      res => {

        if (res.status) {


          this.generalService.notify_msg('success', res.msg);
          // this.bsModalRef.hide();
          
          this.router.navigateByUrl('/test', { skipLocationChange: true })
          .then(() => {
            this.router.navigate([AppFrontRoutes.VIEW_PROBLEM_DETAILS+'/'+this.id]);
          });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          // this.bsModalRef.hide();
        }

        this.check_effectiveness = '#check_effectiveness';
        localStorage.setItem('selectedTab', 'check');


      }
      );
  }

  // add_extraordinary(SID) {
  //   this.extraordinayModal = this.modalService.show(ServicingExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.exodlang } });
  // }

  // edit_extraordinary(ID) {
  //   this.extraordinayModal = this.modalService.show(ServicingExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.exodlang } });
  // }


  // add_ordinary(SID, PID) {
  //   // console.log(PID);
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'PID': PID, 'langs': this.odlang } });
  // }

  // edit_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "edit" } });
  // }


  // duplicate_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "duplicate" } });
  // }


  // add_sdocuments(SID) {
  //   console.log(SID);
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.doclang } });
  // }


  // edit_sdocuments(ID, SID) {
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'langs': this.doclang, 'action': 'edit' } });
  // }

  convetToPDF(ID:any) {
    // var data = document.getElementById('phasefive');  
    // let doc = new jsPDF()
    // // console.log(data);
    // doc.html(data);
    // doc.save('a4.pdf')

    // console.log(ID); return false;
    
    this.problemSolvingService.view_problem_pdfexport(ID).subscribe(
      res => {

        var file = new Blob([res], { type: 'application/pdf' });            
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      

      }
    );
    


  //   var data = document.getElementById('phasefive');  

  //   html2canvas(data).then(canvas => {  
  //     // Few necessary setting options  
  //     var imgWidth = 208;   
  //     var pageHeight = 295;    
  //     var imgHeight = canvas.height * imgWidth / canvas.width;  
  //     var heightLeft = imgHeight;  

  //     const contentDataURL = canvas.toDataURL('image/png')  
  //     let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF  
  //     var position = 0;  
  //     pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)  
  //     pdf.save('MYPdf.pdf'); // Generated PDF   
  // });  



}



sendStake(ID, DID) {
    // console.log(ID); 
    this.sendStakeModal = this.modalService.show(SendStakeHoldersComponent, { class: 'modal-lgs', initialState: { 'ID': this.id, 'langs': this.lang} });
  }





}
